import React from "react";
import "../assets/css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../ThemeComponents/Header";
import Footer from "../ThemeComponents/Footer";
import heroImage from "../assets/images/privateshare.png";

const heroHighlights = [
    "U verdient geld met een auto die normaal stil staat",
    "U bepaalt zelf wanneer uw voertuig beschikbaar is",
    "Huurders reserveren en betalen vooraf online",
    "Borg en betalingen worden automatisch geregeld",
    "Wij ondersteunen bij identificatie en rijbewijscontrole van huurders",
    "Verhuur kan volledig digitaal verlopen",
    "U behoudt altijd controle over uw voertuig en beschikbaarheid"
];

const heroSubtitle = "Verhuur uw auto eenvoudig via het KAV2GO platform";

const detailedSections = [
    {
        id: "insurance",
        title: "Unieke all risk verzekering tijdens de verhuurperiode",
        paragraphs: [
            "Een van de grootste drempels voor particulieren die hun auto willen verhuren, is de verzekering. De meeste reguliere autoverzekeringen staan verhuur aan derden namelijk niet toe. Zodra u uw voertuig verhuurt, loopt u dus het risico dat schade niet gedekt is.",
            "Juist daarom biedt KAV2GO een unieke oplossing: een aanvullende all risk verhuurverzekering die alleen actief is tijdens de daadwerkelijke verhuurperiode.",
            "Dat betekent dat uw eigen autoverzekering gewoon doorloopt voor privegebruik, terwijl tijdens de verhuurperiode een aparte dekking geldt voor de huurder en het voertuig.",
            "Deze verzekering wordt niet berekend op basis van een vast maandbedrag, maar op basis van de gereden kilometers tijdens de huurperiode. Daardoor betaalt u alleen voor het werkelijke gebruik van het voertuig.",
            "Voor particuliere verhuurders is dit een veel eerlijkere en aantrekkelijkere oplossing dan een dure aanvullende verzekering die het hele jaar door loopt.",
            "Daarnaast kan de premie worden aangepast op basis van het risicoprofiel van de bestuurder. Jongere bestuurders of bestuurders met minder rijervaring kunnen bijvoorbeeld een toeslag krijgen. Hierdoor blijft de verzekering betaalbaar voor verhuurders met een laag risicoprofiel.",
            "Deze vorm van tijdelijke all risk dekking maakt particuliere autoverhuur via KAV2GO toegankelijker, veiliger en professioneler dan bij veel andere platformen."
        ]
    },
    {
        id: "checks",
        title: "Veilig verhuren dankzij controle van huurders",
        paragraphs: [
            "Bij particuliere verhuur draait alles om vertrouwen. Daarom zet KAV2GO sterk in op identificatie, rijbewijscontrole en digitale verificatie.",
            "Huurders worden gecontroleerd via een combinatie van documentcontrole, selfie-verificatie en rijbewijsvalidatie. Zo weet u beter aan wie u uw voertuig meegeeft.",
            "Daarnaast worden reserveringen vooraf betaald en kan een borg worden ingesteld. Dat geeft extra zekerheid en voorkomt discussies achteraf."
        ]
    },
    {
        id: "quality",
        title: "Hogere kwaliteit voertuigen dankzij BOVAG-verhuurvoorwaarden",
        paragraphs: [
            "KAV2GO wil zich onderscheiden van algemene deelplatformen door meer focus te leggen op kwaliteit, betrouwbaarheid en zekerheid.",
            "Daarom kijken wij niet alleen naar de huurder, maar ook naar het voertuig dat wordt aangeboden. Voertuigen die via het platform worden verhuurd, moeten voldoen aan duidelijke voorwaarden op het gebied van onderhoud, veiligheid, leeftijd en staat van het voertuig.",
            "Hierbij sluiten wij zoveel mogelijk aan bij de uitgangspunten en kwaliteitseisen die ook binnen de BOVAG-autoverhuur gebruikelijk zijn.",
            "Dat betekent dat huurders via KAV2GO vaker kunnen rekenen op nette, goed onderhouden voertuigen uit het midden- en hogere segment. Voor verhuurders betekent dit dat hun auto wordt gepositioneerd in een platform waar kwaliteit belangrijker is dan alleen de laagste prijs.",
            "Hiermee ontstaat een duidelijk verschil met veel peer-to-peer platformen waar voertuigen sterk in kwaliteit kunnen verschillen."
        ]
    }
];

const vehicleExamples = [
    "Een tweede gezinsauto",
    "Een auto die overdag niet gebruikt wordt",
    "Een bestelbus voor incidenteel transport",
    "Een personenbus voor vakanties of evenementen",
    "Een camper die een deel van het jaar stil staat"
];

const seoTitles = [
    "Auto verhuren via platform | Verdien geld met uw stilstaande auto",
    "Particulier auto verhuren | Veilig en verzekerd via KAV2GO",
    "Geld verdienen met uw auto | Verhuur eenvoudig via KAV2GO"
];

const VoorParticulierenPage = () => {
    return (
        <>
            <title>Auto verhuren via platform | Verdien geld met uw stilstaande auto</title>
            <meta name="description" content="Verdien geld met uw stilstaande auto via KAV2GO. Verhuur uw voertuig veilig,
flexibel en verzekerd met online reserveringen en huurderscontrole." />

            <Header/>
            <div style={{height: "70px"}}></div>

            <main className="front-private-share-page">
                <section className="front-private-share-hero">
                    <div
                        className="front-private-share-hero__bg"
                        style={{
                            backgroundImage: `url(${heroImage})`
                        }}
                    >
                        <div className="container">
                            <div className="front-private-share-hero__content">
                                <h1>Verdien geld met uw auto via ons platform</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="front-private-share-overview">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="front-private-share-overview__content">
                                    <span className="front-private-share-hero__badge">Voor particulieren</span>
                                    <p className="front-private-share-overview__subtitle">{heroSubtitle}</p>
                                    <ul className="front-private-share-overview__list">
                                        {heroHighlights.map((item) => (
                                            <li key={item}>
                                                <span><i className="bi bi-check-lg"></i></span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="front-private-share-intro">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="front-private-share-section">
                                    <p>
                                        Heeft u een auto die vaak stil staat? Dan kunt u er ook geld mee verdienen. Via
                                        het
                                        KAV2GO
                                        platform kunnen particulieren hun auto aanbieden voor verhuur aan anderen.
                                    </p>
                                    <p>
                                        U bepaalt zelf wanneer uw voertuig beschikbaar is, tegen welke prijs en voor
                                        welke
                                        periode.
                                        Veel voertuigen staan een groot deel van de week stil. Met KAV2GO verandert u
                                        dat in een
                                        extra inkomstenbron.
                                    </p>
                                    <p>
                                        Ons platform is ontwikkeld vanuit tientallen jaren ervaring in autoverhuur,
                                        deelmobiliteit
                                        en online reserveringen. Daardoor begrijpen wij welke zekerheid particuliere
                                        verhuurders
                                        nodig hebben.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {detailedSections.map((section, index) => (
                    <section
                        key={section.id}
                        className={`front-private-share-details ${index % 2 === 1 ? "front-private-share-details--alt" : ""}`}
                    >
                        <div className="container">
                            <div className="front-private-share-section">
                                <h2>{section.title}</h2>
                                {section.paragraphs.map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                            </div>
                        </div>
                    </section>
                ))}

                <section className="front-private-share-vehicles">
                    <div className="container">
                        <div className="front-private-share-section">
                            <h2>Voor welke voertuigen is het platform geschikt?</h2>
                            <p>
                            Niet alleen personenauto&apos;s zijn interessant voor verhuur. Ook bestelbusjes, personenbussen,
                                campers of bijzondere voertuigen kunnen via het platform worden aangeboden.
                            </p>
                            <p>Denk bijvoorbeeld aan:</p>
                            <ul className="front-private-share-vehicles__list">
                                {vehicleExamples.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                            <p>
                                Vooral voertuigen die regelmatig ongebruikt blijven, kunnen interessant zijn om extra inkomsten
                                mee te genereren.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="front-private-share-flex">
                    <div className="container">
                        <div className="front-private-share-section">
                            <h2>Zelf bepalen, zonder verplichtingen</h2>
                            <p>
                                U bepaalt zelf hoe vaak u uw voertuig beschikbaar stelt: alleen in het weekend, tijdens
                                vakanties of juist doordeweeks.
                            </p>
                            <p>
                                Er zijn geen vaste verplichtingen om uw auto permanent beschikbaar te maken. U houdt de regie,
                                terwijl KAV2GO helpt bij reserveringen, betalingen, controles en verzekering.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="front-private-share-cta">
                    <div className="container">
                        <h2>Begin met verhuren via KAV2GO</h2>
                        <p>
                            Wilt u weten wat uw auto kan opleveren? Of bent u benieuwd hoe het werkt om uw voertuig veilig
                            via een platform te verhuren?
                        </p>
                        <p>
                            Neem dan contact op met KAV2GO. Wij laten u graag zien hoe particuliere verhuur werkt en welke
                            mogelijkheden er zijn voor uw voertuig.
                        </p>
                        <div className="front-private-share-cta__actions">
                            <a href="mailto:info@kav2go.nl?subject=Particulier%20auto%20verhuren">Neem contact op</a>
                            <a href="tel:0880883434">Bel direct</a>
                        </div>
                    </div>
                </section>
            </main>

            <Footer/>
        </>
    );
};

export default VoorParticulierenPage;
